/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

const SERVICE_ENDPOINT = import.meta.env.VITE_APP_BACKEND_SERVICE;

/**
 * GET /v1/addFavorite/services?page=&limit=
 * Returns paginated full service info for customer's favorites.
 */
export const getFavoriteServices = async (params: {
  page?: number;
  limit?: number;
}): Promise<any> => {
  const { page = 1, limit = 12 } = params;
  const res = await apiClient.get(
    `${SERVICE_ENDPOINT}/${Path.addFavorite}/services`,
    { params: { page, limit } }
  );
  return res.data;
};

/**
 * GET /v1/addFavorite/services/ids
 * Returns all favorited service IDs for authenticated customer/provider account.
 */
export const getAvailableFavoriteServiceIds = async (): Promise<string[]> => {
  const res = await apiClient.get(
    `${SERVICE_ENDPOINT}/${Path.addFavorite}/services/ids`
  );
  const ids = res?.data?.data?.serviceIds;
  return Array.isArray(ids) ? ids : [];
};

/**
 * POST /v1/addFavorite
 */
export const addFavoriteService = async (serviceId: string): Promise<any> => {
  if (!serviceId) throw new Error('serviceId is required');
  const res = await apiClient.post(`${SERVICE_ENDPOINT}/${Path.addFavorite}`, {
    serviceId,
  });
  return res.data;
};

/**
 * DELETE /v1/addFavorite/:serviceId
 */
export const removeFavoriteService = async (
  serviceId: string
): Promise<any> => {
  if (!serviceId) throw new Error('serviceId is required');
  const res = await apiClient.delete(
    `${SERVICE_ENDPOINT}/${Path.addFavorite}/${encodeURIComponent(serviceId)}`
  );
  return res.data;
};

/**
 * GET /v1/addFavorite/count/service/:serviceId (public)
 */
export const getServiceFavoriteCountPublic = async (
  serviceId: string
): Promise<number> => {
  if (!serviceId) return 0;
  const res = await apiClient.get(
    `${SERVICE_ENDPOINT}/${Path.addFavorite}/count/service/${encodeURIComponent(serviceId)}`
  );
  const count = res?.data?.data?.favoriteCount;
  return typeof count === 'number' ? count : 0;
};
